import {
  ACCEPT_KVKK_AGREEMENT_REQUEST,
  ACCEPT_KVKK_AGREEMENT_SUCCESS,
  ACCEPT_KVKK_AGREEMENT_FAILURE,
  GET_KVKK_AGREEMENT_REQUEST,
  GET_KVKK_AGREEMENT_SUCCESS,
  GET_KVKK_AGREEMENT_FAILURE,
  LOGIN_SUCCESS
} from 'Store/constants';

const initialState = {
  data: {},
  isAccepted: null,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACCEPT_KVKK_AGREEMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case ACCEPT_KVKK_AGREEMENT_SUCCESS:
      return { ...state, isAccepted: action.payload, isLoading: false, error: null };
    case LOGIN_SUCCESS:
      return { ...state, isAccepted: action.payload.isReadLatestPolicy, isLoading: false, error: null };
    case ACCEPT_KVKK_AGREEMENT_FAILURE:
      return { ...initialState, isLoading: false, error: action.payload };
    case GET_KVKK_AGREEMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_KVKK_AGREEMENT_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_KVKK_AGREEMENT_FAILURE:
      return { ...initialState, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
